/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentageQueryResponse,
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentagePathParams,
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage401,
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage500,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage } from "../../clients/individualPaymentEditorsController/getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage.ts";

export const getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentageQueryKey =
  (
    discountTypeId: GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentagePathParams["discountTypeId"],
  ) =>
    [
      {
        url: "/api/v1/individualpayment/editors/discount-types/:discountTypeId/percentage",
        params: { discountTypeId: discountTypeId },
      },
    ] as const;

export type GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentageQueryKey =
  ReturnType<
    typeof getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentageQueryKey
  >;

export function getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentageQueryOptions(
  discountTypeId: GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentagePathParams["discountTypeId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentageQueryKey(
      discountTypeId,
    );
  return queryOptions<
    GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentageQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage401
      | GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage500
    >,
    GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentageQueryResponse,
    typeof queryKey
  >({
    enabled: !!discountTypeId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage(
        discountTypeId,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Migrado do legado RegistryAsync/GetDiscountPercentage. **(Requer Authorization para autenticação)**
 * @summary Percentual do tipo de desconto (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/editors/discount-types/:discountTypeId/percentage}
 */
export function useGetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage<
  TData =
    GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentageQueryResponse,
  TQueryData =
    GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentageQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentageQueryKey,
>(
  discountTypeId: GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentagePathParams["discountTypeId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentageQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage401
          | GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentageQueryKey(
      discountTypeId,
    );

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentageQueryOptions(
        discountTypeId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage401
      | GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidPercentage500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
